import { render } from "./IncomeEvent.vue?vue&type=template&id=135a5be4&scoped=true"
import script from "./IncomeEvent.vue?vue&type=script&lang=js"
export * from "./IncomeEvent.vue?vue&type=script&lang=js"

import "./IncomeEvent.vue?vue&type=style&index=0&id=135a5be4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135a5be4"]])

export default __exports__